import React, { useEffect, useMemo, useState } from 'react';
import { Grid, Typography, Box, Container } from '@mui/material';
import Image from 'next/image';
import styles from './OverviewNewProducts.module.scss';
import imgLoader from '../../../../../imgloader';
import { content } from '../../../../../commons/Constants/OverviewNewProd';
import { useAppDispatch, useAppSelector } from '../../../../../src/app/hooks';
import { setSelectedVariantData } from '../../../../../src/features/user/userState';
import { ProductsCategory } from '../../../../../config';
import { useRouter } from 'next/router';
export default function OverViewNewProducts({ id, productType }) {
  const dispatch = useAppDispatch();
  const selectedVariantFromRedux = useAppSelector(
    (state) => state.user.selectedVariantData
  );
  const router = useRouter();
  const variantFromQuery = router.query.variant;
  const [selectedVariant, setSelectedVariant] = useState('DK2');

  useEffect(() => {
    const normalized =
      (variantFromQuery || selectedVariantFromRedux)?.replace('D_', 'D') ||
      'DK2';
    setSelectedVariant(normalized);
  }, [variantFromQuery, selectedVariantFromRedux]);

  const contentKey = [
    ProductsCategory.VITAMIN_D_K2,
    ProductsCategory.VITAMIN_D_K5,
  ].includes(productType)
    ? selectedVariant
    : productType;
  const productContent = content[contentKey];

  if (!productContent) {
    console.warn('Missing content for:', contentKey);
    return null;
  }

  const {
    title1,
    title2,
    title3,
    subtitle,
    section,
    img1,
    img2,
    icon,
    imageProps,
  } = productContent;
  return (
    <div className={styles.overViewExtender} id={id}>
      <div className={styles.overViewSection}>
        <Container maxWidth="xl" className={styles.mainContainer}>
          <Grid container className={styles.gridContainer}>
            {/* LEFT SIDE: Text content */}
            <Grid item sm={12} md={6} lg={6}>
              <Box className={styles.textContainer}>
                <div className={styles.iconContainer}>
                  <Box component="span" className={styles.icon}>
                    {icon}
                  </Box>
                  <Typography
                    variant="h5"
                    component="span"
                    color="primary.main"
                    gutterBottom
                    className={styles.subtitle}
                  >
                    {subtitle}
                  </Typography>
                </div>

                <Typography
                  variant="h1"
                  color="primary.main"
                  className={styles.title1}
                >
                  {title1} <br />
                </Typography>
                <Typography
                  variant="h1"
                  color="primary.light"
                  className={styles.title2}
                >
                  {title2}
                </Typography>
                <Typography
                  variant="h1"
                  gutterBottom
                  color="primary.main"
                  dangerouslySetInnerHTML={{
                    __html: title3,
                  }}
                  className={styles.title1}
                ></Typography>
                <Typography
                  variant="p1-book"
                  color="primary.black"
                  mb={3}
                  sx={{ textWrap: 'pretty' }}
                >
                  {section}
                </Typography>
              </Box>
            </Grid>

            {/* RIGHT SIDE: Product image */}
            <Grid
              item
              sm={12}
              md={5}
              lg={5}
              display={'flex'}
              alignItems={'center'}
              justifyContent={'center'}
            >
              <Box className={styles.imageContainer}>
                <Image
                  src={img1}
                  blurDataURL={img1}
                  alt="Antioxidants with Vitamin C & Bioflavonoids"
                  loader={imgLoader}
                  width={400}
                  height={400}
                  objectFit="cover"
                  placeholder="blur"
                  priority
                  className={`${styles.productImage}  ${imageProps?.objpostop ? styles.positionTop : ''}`}
                  {...imageProps}
                />
                {/* <Image
                  src={img2}
                  blurDataURL={img2}
                  alt="Antioxidants with Vitamin C & Bioflavonoids"
                  loader={imgLoader}
                  layout="fill"
                  placeholder="blur"
                  className={styles.productImage}
                /> */}
              </Box>
            </Grid>
          </Grid>
        </Container>
      </div>
    </div>
  );
}
